import createClient from '@/shared/api/apolloClient';
import type {
  RequestFileUploadQuery,
  RequestFileUploadQueryVariables,
} from '@/shared/api/__generated__/graphql';
import REQUEST_FILE_UPLOAD_QUERY from '../queries/requestFileUpload';

/**
 * Obtains pre-signed upload URLs for attaching files such as RMA or report documents. Queries requestFileUpload with the file type and requested amount and throws the returned message when the request is unsuccessful.
 *
 * @param type - File category to request upload slots for.
 * @param amount - Number of upload URLs to request.
 * @returns List of pre-signed upload URLs.
 */
const handleRequestFileUpload = async (type: string, amount: number) => {
  const client = createClient();
  const requestFileUploadResult = await client.query<
    RequestFileUploadQuery,
    RequestFileUploadQueryVariables
  >({
    query: REQUEST_FILE_UPLOAD_QUERY,
    variables: {
      input: {
        type,
        amount,
      },
    },
  });
  const { data } = requestFileUploadResult;
  const { requestFileUpload } = data;
  if (!requestFileUpload.isSuccess) {
    throw new Error(requestFileUpload.message ?? undefined);
  }
  return requestFileUpload.urls;
};

export default handleRequestFileUpload;
